'use client';
import { useLocaleStore } from '@eliadmin/core/src/stores/locale-store';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import { forwardRef, useEffect, useRef, useState } from 'react';
import type { PhoneInputProps } from 'react-international-phone';
import { PhoneInput } from 'react-international-phone';
import './phone-input-styles.css';

export const PhoneInputField = forwardRef(
  ({
    className,
    variant,
    ...props
  }: PhoneInputProps & {
    variant?: 'outlined' | 'default';
  }) => {
    const [focused, setFocused] = useState(false);
    const phoneInputRef = useRef(null);

    const locale = useLocaleStore(s => s.currentLocale);

    const defaultCountryFromLocale = () => {
      if (locale === 'cs') {
        return 'cz';
      }

      return locale;
    };

    useEffect(() => {
      const handleClickOutside = (event: any) => {
        const current = phoneInputRef.current as any;

        if (current && !current.contains(event.target)) {
          setFocused(false);
        }
      };

      document.addEventListener('mousedown', handleClickOutside);
      return () => {
        document.removeEventListener('mousedown', handleClickOutside);
      };
    }, [phoneInputRef]);

    return (
      <div
        ref={phoneInputRef}
        className={cn(
          focused ? 'outline outline-1 outline-primary' : 'outline-none',
          variant === 'outlined' ? 'border-1 border border-border' : 'border-none',
          className,
        )}
      >
        <PhoneInput
          defaultCountry={defaultCountryFromLocale()}
          name="phone"
          onFocus={() => setFocused(true)}
          onBlur={() => setFocused(false)}
          inputClassName={cn('bg-input')}
          inputStyle={{
            backgroundColor: 'hsl(var(--input)) !important',
            height: '48px !important',
            paddingLeft: '20px',
            width: '100%',
            border: 'none',
          }}
          countrySelectorStyleProps={{
            buttonClassName: 'bg-input',
            buttonStyle: {
              height: '48px !important',
              backgroundColor: 'hsl(var(--input)) !important',
              paddingLeft: '12px',
              border: 'none',
            },
          }}
          {...props}
        />
      </div>
    );
  },
);

PhoneInputField.displayName = 'PhoneInputField';
